"use strict";

var quizPoints = 0;

document.querySelectorAll('.js-quiz-start').forEach(function (button) {
  button.addEventListener('click', function () {
    document.querySelector('.quiz-container').classList.add('active');
    var startBlock = document.querySelector('.quiz-quests__start');
    var listBlock = document.querySelector('.quiz-quests__list');
    startBlock.style.display = 'none';
    listBlock.classList.add('fade');
  });
});

document.addEventListener('change', function (e) {
  if (e.target.matches('.list-quest__item input[type="radio"]')) {
    var questItem = e.target.closest('.item__quest');
    var checkButton = questItem === null || questItem === void 0 ? void 0 : questItem.querySelector('.js-quiz-check');
    if (checkButton) {
      checkButton.removeAttribute('disabled');
    }
    var platformNumber = e.target.value.split('_')[0];
    var selectedValue = e.target.value.split('_')[1];
    var platformId = "platform_".concat(platformNumber);
    var targetId = "".concat(platformId, "_").concat(selectedValue);
    if (e.target.name === 'quest_3') {
      document.querySelectorAll('.quiz-platform__elem[data-platform="platform_2"]').forEach(function (elem) {
        elem.style.display = 'none';
        elem.classList.remove('show');
      });
      var questDop = document.querySelector('.list-quest__item input[name="quest_2"]:checked').value;
      var questDopId = questDop.split('_')[1];
      targetId = "".concat(platformId, "_").concat(selectedValue, "_").concat(questDopId);
    }
    document.querySelectorAll(".quiz-platform__elem[data-platform=\"".concat(platformId, "\"]")).forEach(function (elem) {
      return elem.classList.remove('show');
    });
    document.querySelectorAll(".quiz-platform__elem[data-platform=\"".concat(platformId, "\"]")).forEach(function (elem) {
      return elem.classList.remove('selected');
    });
    document.querySelectorAll(".quiz-platform__elem[data-platform=\"".concat(platformId, "\"][data-id=\"").concat(targetId, "\"]")).forEach(function (targetElem) {
      if (targetElem) {
        targetElem.classList.add('show');
        targetElem.classList.add('selected');
      }
    });
  }
});

document.querySelectorAll('.js-quiz-check').forEach(function (button) {
  button.addEventListener('click', function (e) {
    var questItem = e.target.closest('.quiz-quests__item');
    var itemQuest = questItem.querySelector('.item__quest');
    var itemResult = questItem.querySelector('.item__result');
    var selectedValue = questItem.querySelector('.list-quest__item input[type="radio"]:checked');
    var questNumber = selectedValue.value;
    var platformNumber = selectedValue.value;
    var numberQuest = selectedValue.value.split('_')[1];
    var targetElem = questItem.querySelector(".item-result__image-elem[data-id=\"".concat(platformNumber, "\"]"));
    if (targetElem) {
      targetElem.style.display = 'block';
    }
    var questData = quizQuests.quests[questNumber];
    if (questData) {
      itemResult.querySelector('.item-result__selected').innerHTML = questData.selected_text;
      itemResult.classList.add("selected_".concat(numberQuest));
      quizPoints += questData.points;
      document.querySelector('input[name="points"]').value = quizPoints;
      document.querySelectorAll('.quiz-quests__count-text').forEach(function (countEl) {
        countEl.innerHTML = getPointsText(quizPoints);
      });
      if (questData.success) {
        itemResult.classList.add('success');
      } else {
        itemResult.classList.add('error');
        itemResult.querySelector('.item-result__counsel').innerHTML = questData.counsel_text;
        itemResult.querySelector('.item-result__counsel').style.display = 'block';
      }
    } else {
      console.log("Нет данных для платформы:", questNumber);
    }
    itemQuest.style.display = 'none';
    itemResult.classList.add('active');
  });
});
function getPointsText(number) {
  var titles = ['очко', 'очка', 'очков'];
  var cases = [2, 0, 1, 1, 1, 2];
  var word = titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
  return "".concat(number, " ").concat(word);
}
document.querySelectorAll('.js-quiz-next').forEach(function (button) {
  button.addEventListener('click', function (e) {
    var targetId = button.getAttribute('data-id');
    document.querySelectorAll('.quiz-quests__item').forEach(function (item) {
      item.style.display = 'none';
      item.classList.remove('active');
    });
    var targetItem = document.querySelector(".quiz-quests__item[data-id=\"".concat(targetId, "\"]"));
    if (targetItem) {
      targetItem.style.display = 'flex';
      targetItem.classList.add('active');
    }
    hidePlatformElem(button);
  });
});
function hidePlatformElem(button) {
  var targetId = button.getAttribute('data-id');
  if (targetId === 'quest_2') {
    document.querySelector('.quiz-platform').classList.add('zoom');
    var platformsToShow = ['ground'];
    platformsToShow.forEach(function (platform) {
      document.querySelectorAll(".quiz-platform__elem.selected[data-platform=\"".concat(platform, "\"]")).forEach(function (elem) {
        elem.style.display = 'block';
        elem.classList.add('show');
      });
    });
    document.querySelectorAll('.quiz-platform__elem[data-platform="platform_1"]').forEach(function (elem) {
      elem.style.display = 'none';
      elem.classList.remove('show');
    });
  }
  if (targetId === 'quest_4') {
    document.querySelectorAll('.quiz-platform__elem[data-platform="platform_3"]').forEach(function (elem) {
      elem.style.display = 'none';
      elem.classList.remove('show');
    });
  }
  if (targetId === 'quest_5') {
    document.querySelector('.quiz-platform').classList.remove('zoom');
    var platformsToHide = ['ground'];
    platformsToHide.forEach(function (platform) {
      document.querySelectorAll(".quiz-platform__elem[data-platform=\"".concat(platform, "\"]")).forEach(function (elem) {
        elem.style.display = 'none';
        elem.classList.remove('show');
      });
    });
    document.querySelectorAll('.quiz-platform__elem[data-platform="platform_4"]').forEach(function (elem) {
      elem.style.display = 'none';
      elem.classList.remove('show');
    });
  }
  if (targetId === 'quest_6') {
    var _platformsToHide = ['platform_5'];
    _platformsToHide.forEach(function (platform) {
      document.querySelectorAll(".quiz-platform__elem[data-platform=\"".concat(platform, "\"]")).forEach(function (elem) {
        elem.style.display = 'none';
        elem.classList.remove('show');
      });
    });
    var _platformsToShow = ['ground'];
    _platformsToShow.forEach(function (platform) {
      document.querySelectorAll(".quiz-platform__elem.selected[data-platform=\"".concat(platform, "\"]")).forEach(function (elem) {
        elem.style.display = 'block';
        elem.classList.add('show');
      });
    });
    document.querySelector('.quiz-platform__elem[data-platform="storage"]').classList.add('show');
    document.querySelector('.quiz-platform__elem[data-platform="storage"]').classList.add('selected');
  }
  if (targetId === 'quest_9') {
    document.querySelector('.quiz-platform').classList.add('zoom-2');
    var _platformsToHide2 = ['ground', 'storage', 'platform_6', 'platform_7'];
    _platformsToHide2.forEach(function (platform) {
      document.querySelectorAll(".quiz-platform__elem[data-platform=\"".concat(platform, "\"]")).forEach(function (elem) {
        elem.style.display = 'none';
        elem.classList.remove('show');
      });
    });
    var _platformsToShow2 = ['platform_5'];
    _platformsToShow2.forEach(function (platform) {
      document.querySelectorAll(".quiz-platform__elem.selected[data-platform=\"".concat(platform, "\"]")).forEach(function (elem) {
        elem.style.display = 'block';
        elem.classList.add('show');
      });
    });
  }
  if (targetId === 'quest_12') {
    document.querySelector('.quiz-platform').classList.remove('zoom-2');
    var _platformsToHide3 = ['platform_5', 'platform_9', 'platform_10', 'platform_11'];
    _platformsToHide3.forEach(function (platform) {
      document.querySelectorAll(".quiz-platform__elem[data-platform=\"".concat(platform, "\"]")).forEach(function (elem) {
        elem.style.display = 'none';
        elem.classList.remove('show');
      });
    });
    var _platformsToShow3 = ['ground', 'storage', 'platform_6', 'platform_7'];
    _platformsToShow3.forEach(function (platform) {
      document.querySelectorAll(".quiz-platform__elem.selected[data-platform=\"".concat(platform, "\"]")).forEach(function (elem) {
        elem.style.display = 'block';
        elem.classList.add('show');
      });
    });
  }
}
document.querySelectorAll('.js-quiz-finish').forEach(function (button) {
  button.addEventListener('click', function (e) {
    var link = document.querySelector('input[name="link"]').value;
    if (quizPoints < 60) {
      var resultImg = document.querySelector('input[name="result-3"]').value;
      setShareLinks(link, 'Спецпроект ГК «Промплан» и CRE.ru', "\u041D\u0430\u0431\u0440\u0430\u043B ".concat(quizPoints, " \u0431\u0430\u043B\u043B\u043E\u0432 \u0432 \u043A\u0432\u0438\u0437\u0435 \u041F\u0420\u041E\u041C\u041F\u041B\u0410\u041D. \u041C\u043E\u0438 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043B\u0443\u0447\u0448\u0435, \u0447\u0435\u043C \u0443 30% \u043B\u044E\u0434\u0435\u0439. \u042F \u043C\u0430\u0441\u0442\u0435\u0440 \u0431\u0435\u0442\u043E\u043D\u043D\u044B\u0445 \u0433\u0440\u0430\u0431\u043B\u0435\u0439. #\u043F\u0440\u043E\u043C\u043F\u043B\u0430\u043D"), resultImg);
      document.querySelector('.finish-form__header').classList.add('place-3');
      document.querySelector('.js-finish-text').innerHTML = 'Ты мастер бетонных граблей';
      document.querySelector('.js-finish-percent').innerHTML = '30%';
    } else if (quizPoints >= 60 && quizPoints < 80) {
      var _resultImg = document.querySelector('input[name="result-2"]').value;
      setShareLinks(link, 'Спецпроект ГК «Промплан» и CRE.ru', "\u041D\u0430\u0431\u0440\u0430\u043B ".concat(quizPoints, " \u0431\u0430\u043B\u043B\u043E\u0432 \u0432 \u043A\u0432\u0438\u0437\u0435 \u041F\u0420\u041E\u041C\u041F\u041B\u0410\u041D. \u041C\u043E\u0438 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043B\u0443\u0447\u0448\u0435, \u0447\u0435\u043C \u0443 50% \u043B\u044E\u0434\u0435\u0439. \u042F \u0438\u043D\u0436\u0435\u043D\u0435\u0440 \u0437\u0434\u0440\u0430\u0432\u043E\u0433\u043E \u0441\u043C\u044B\u0441\u043B\u0430. #\u043F\u0440\u043E\u043C\u043F\u043B\u0430\u043D"), _resultImg);
      document.querySelector('.finish-form__header').classList.add('place-2');
      document.querySelector('.js-finish-text').innerHTML = 'Ты инженер здравого смысла';
      document.querySelector('.js-finish-percent').innerHTML = '50%';
    } else if (quizPoints >= 80) {
      var _resultImg2 = document.querySelector('input[name="result-1"]').value;
      setShareLinks(link, 'Спецпроект ГК «Промплан» и CRE.ru', "\u041D\u0430\u0431\u0440\u0430\u043B ".concat(quizPoints, " \u0431\u0430\u043B\u043B\u043E\u0432 \u0432 \u043A\u0432\u0438\u0437\u0435 \u041F\u0420\u041E\u041C\u041F\u041B\u0410\u041D. \u041C\u043E\u0438 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043B\u0443\u0447\u0448\u0435, \u0447\u0435\u043C \u0443 70% \u043B\u044E\u0434\u0435\u0439. \u042F \u0433\u0435\u043D\u0438\u0439 \u043C\u043E\u0434\u0443\u043B\u044C\u043D\u044B\u0445 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440. #\u043F\u0440\u043E\u043C\u043F\u043B\u0430\u043D"), _resultImg2);
      document.querySelector('.finish-form__header').classList.add('place-1');
      document.querySelector('.js-finish-text').innerHTML = 'Ты гений модульных структур';
      document.querySelector('.js-finish-percent').innerHTML = '70%';
    }
    modalOpen('finish');
  });
});
function setShareLinks(url, title, desc, image) {
  var encodedUrl = encodeURIComponent(url);
  var encodedTitle = encodeURIComponent(title);
  var encodedDesc = encodeURIComponent(desc);
  var encodedImage = encodeURIComponent(image);
  document.getElementById('share-vk').href = "https://vk.com/share.php?url=".concat(encodedUrl, "&title=").concat(encodedTitle, "&comment=").concat(encodedDesc, "&image=").concat(encodedImage, "&noparse=true");
  document.getElementById('share-tg').href = "https://t.me/share/url?url=".concat(encodedUrl, "&text=").concat(encodedDesc);
}